import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useLazyQuery } from '@apollo/client';
import { GET_CURRENT_USER } from '../../apollo/queries/user';
import AuthService from '../../auth/storage';
import { setAuthState } from '../../redux/slices/authSlice';
import { fetchAthleteDashboard } from '../../redux/slices/athleteSlice';
import { fetchCoachDashboard } from '../../redux/slices/coachSlice';
import { fetchPendingCoaches, fetchApprovedCoaches } from '../../redux/slices/adminSlice';

const useAuthInitializer = () => {
  const dispatch = useDispatch();
  const [getCurrentUser, { called, loading }] = useLazyQuery(GET_CURRENT_USER, {
    fetchPolicy: 'no-cache',
  });

  const runAuthBootstrap = useCallback(() => {
    return new Promise((resolve) => {
      const token = AuthService.getToken();
      if (token) {
        getCurrentUser().then(({ data }) => {
          if (data?.getCurrentUser) {
            const { _id, role, email } = data.getCurrentUser;

            if (role) {
              dispatch(setAuthState({ _id, role, email }));
            } else {
              console.warn('Missing role in getCurrentUser, skipping auth state update');
            }

            switch (role) {
              case 'coach':
                dispatch(fetchCoachDashboard()).finally(resolve);
                break;
              case 'athlete':
                dispatch(fetchAthleteDashboard()).finally(resolve);
                break;
              case 'admin':
                Promise.all([
                  dispatch(fetchPendingCoaches()),
                  dispatch(fetchApprovedCoaches())
                ]).finally(resolve);
                break;
              default:
                resolve();
            }
          } else {
            dispatch({ type: 'auth/setBootstrapped' });
            resolve();
          }
        });
      } else {
        dispatch({ type: 'auth/setBootstrapped' });
        resolve();
      }
    });
  }, [getCurrentUser, dispatch]);

  useEffect(() => {
    if (!called && !loading) {
      runAuthBootstrap();
    }
  }, [called, loading, runAuthBootstrap]);

  return { runAuthBootstrap };
};

export default useAuthInitializer;